<template>
  <v-data-table
    :headers="headers"
    :items="users"
    :options.sync="options"
    :search="search"
    :footer-props="{
      'items-per-page-options': [10, 20, 30, 40, 50, -1]
    }"
    dense
    item-key="users_id"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-text-field
        v-model="search"
        label="Search"
        class="mx-4"
      />
    </template>
    <template v-slot:item.view_logs="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.control_service="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.deploy_service="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.edit_contract="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.edit_server="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.edit_sizing="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.edit_users="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.delete_server="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.edit_notes="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.view_dr_contract="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.view_f5_details="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.api_access="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.decom_contract="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
    <template v-slot:item.edit_software="{ value }">
      <v-icon
        :color="iconColour(value)"
      >
        {{ displayIcon(value) }}
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
 export default {
    name: 'UserPermissionsTable',
    props: {
      users: Array,
    },
    data () {
      return {
        search: '',
        headers: [
          { value: 'name', text: 'Name' },
          { value: 'view_logs', text: 'View Logs' },
          { value: 'control_service', text: 'Control Service' },
          { value: 'deploy_service', text: 'Deploy Service' },
          { value: 'edit_contract', text: 'Edit Contract' },
          { value: 'edit_server', text: 'Edit Server' },
          { value: 'edit_sizing', text: 'Edit Sizing' },
          { value: 'edit_users', text: 'Edit Users' },
          { value: 'delete_server', text: 'Delete Server' },
          { value: 'edit_notes', text: 'Edit Notes' },
          { value: 'view_dr_contract', text: 'View DR Contracts' },
          { value: 'view_f5_details', text: 'View F5 Details' },
          { value: 'api_access', text: 'API Access' },
          { value: 'decom_contract', text: 'Decom Contract' },
          { value: 'edit_software', text: 'Edit Software' }
        ],
        options: {
          itemsPerPage: 50,
          sortBy: ['name'],
        },
      }
    },
    methods: {
      displayIcon: function(item) {
        if (item === 'y') {
          return 'mdi-check'
        } else {
          return 'mdi-close'
        }
      },
      iconColour: function(item) {
        if (item === 'y') {
          return 'success'
        } else {
          return 'error'
        }
      }
    }
 }
</script>
<style scoped>
:deep().v-data-table__wrapper > table > thead > tr > th,
:deep().v-data-table__wrapper > table > tbody > tr > td {
  font-size: 0.75rem;
}
</style>